import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { yourInformationSelector } from '../../../../store/reducers/yourInfoReducer';
import { servicesSelector } from '../../../../store/reducers/selServReducer';
import { primaryContractSelector } from '../../../../store/reducers/primConReducer';
import { secondContractSelector } from '../../../../store/reducers/secConReducer';
import { pathsSelector } from '../../../../store/reducers/pathsReducer';
import { promoCodeSelector } from '../../../../store/reducers/promoCodeReducer';

function ProgressionBarLarge({ item, progression }) {
    const circleInActive = "circleLarge inactive";
    const pActive = "active";
    const selectedServices = useSelector(servicesSelector);
    const promoCode = useSelector(promoCodeSelector);
    const yourInfo = useSelector(yourInformationSelector);
    const primCon = useSelector(primaryContractSelector);
    const secCon = useSelector(secondContractSelector);
    const paths = useSelector(pathsSelector);
    let history = useHistory();
    const [lineStyles, setLineStyles] = useState("");

    useEffect(() => {
        if(item >= 1) {
            setLineStyles("progression-line billing form");
            if(promoCode.isHuri === true) {
                setLineStyles("progression-line billing form longer");
            }
        } else {
            setLineStyles("progression-line billing");
            if(promoCode.isHuri === true) {
                setLineStyles("progression-line billing form longer");
            }
        }
      }, []); // eslint-disable-line

    const handleNext = click => e => {
        let pushAccepted = false;

        switch(click) {
            case "services": 
                click = "/form"
                pushAccepted = true;
                break;
            case "yourInfo":                 
                if((paths.includes("/form"))) {
                    click = "/form/info";
                    pushAccepted = true;
                }
                break;
            case "contractAdmin": 
                if((paths.includes("/form/primary"))) {
                    click = "/form/secondary"
                    pushAccepted = true;
                } else if((paths.includes("/form/info"))) {
                    click = "/form/primary";
                    pushAccepted = true;
                }
                break;
            case "nomination": 
                if((paths.includes("/form/primary")) && (paths.includes("/form/secondary"))) {
                    click = "/form/nomination";
                    pushAccepted = true;
                }
                break;
            case "submit": 
                if((JSON.stringify(secCon).length > 2) && (JSON.stringify(primCon).length > 2) && (JSON.stringify(yourInfo).length > 2) && (selectedServices.length > 0)) {
                    if(promoCode.isHuri === true && promoCode.code === "") {
                    } else {
                        click = "/form/summary";
                        pushAccepted = true;
                        console.log("promocode is mot empty")
                    }
                }
                break;
            default:
                break;
        }
        if((pushAccepted === true) && click !== history.location.pathname) { 
            history.push(click)
        }
    };

    return (
        <div className="progression-barLarge_container">     
            {promoCode.isHuri === true ?                 
                <> 
                    <div className="progression-barLarge">
                        <div className="clickable" onClick={handleNext("services")}>
                            <div className="circleLarge"></div>
                            <div className={(paths.includes("/form")) && (selectedServices.length > 0) ? "p1 completed" : "p1"}><p className={item === 1 ? pActive : ""}>Confirm service</p></div>
                        </div>
                        <div className={paths.includes("/form") ? "clickable" : ""} onClick={handleNext("yourInfo")}>
                            <div className={(progression === "/form/info") || (item >= 2) ? "circleLarge" : circleInActive }></div>
                            <div className={JSON.stringify(yourInfo).length > 2 ? "p2 completed" : "p2"}><p className={item === 2 ? pActive : ""}>Your information</p></div>
                        </div>
                        <div className={paths.includes("/form/info") || paths.includes("/form/secondary") ? "clickable" : ""} onClick={handleNext("contractAdmin")}>
                            <div className={((progression === "/form/primary") || (progression === "/form/secondary")) || (item >= 3) ? "circleLarge" : circleInActive}></div>
                            <div className={(JSON.stringify(secCon).length > 2) && (JSON.stringify(primCon).length > 2) ? "p3 completed" : "p3"}><p className={item === 3 ? pActive : ""}>Contract administrators</p></div>
                        </div>
                        <div className={paths.includes("/form/secondary") ? "clickable" : ""} onClick={handleNext("nomination")}>
                            <div className={(progression === "/form/nomination") || (item >= 4) ? "circleLarge" : circleInActive}></div>
                            <div className={promoCode.code !== "" ? "p4 completed" : "p4"}><p className={item === 4 ? pActive : "" }>Nomination code</p></div>
                        </div>
                        <div className={paths.includes("/form/nomination") ? "clickable" : ""} onClick={handleNext("submit")}>
                            <div className={(progression === "/form/summary") || (item >= 5) ? "circleLarge" : circleInActive}></div>
                            <div className="p5"><p className={item === 5 ? pActive : "" }>Submit</p></div>
                        </div>
                    </div>
                    <div className={lineStyles}></div>
                </>
                :<>
                    <div className="progression-barLarge">
                        <div className="clickable" onClick={handleNext("services")}>
                            <div className={(progression === "/form") || (item >= 1) ? "circleLarge" : circleInActive }></div>
                            <div className={(paths.includes("/form")) && (selectedServices.length > 0) ? "p1 completed" : "p1"}><p className={item === 1 ? pActive : ""}>Confirm service</p></div>
                        </div>
                        <div className={paths.includes("/form") ? "clickable" : ""} onClick={handleNext("yourInfo")}>
                            <div className={(progression === "/form/info") || (item >= 2) ? "circleLarge" : circleInActive }></div>
                            <div className={JSON.stringify(yourInfo).length > 2 ? "p2 completed" : "p2"}><p className={item === 2 ? pActive : ""}>Your information</p></div>
                        </div>
                        <div className={paths.includes("/form/info") || paths.includes("/form/secondary") ? "clickable" : ""} onClick={handleNext("contractAdmin")}>
                            <div className={((progression === "/form/primary") || (progression === "/form/secondary")) || (item >= 3) ? "circleLarge" : circleInActive}></div>
                            <div className={(JSON.stringify(secCon).length > 2) && (JSON.stringify(primCon).length > 2) ? "p3 completed" : "p3"}><p className={item === 3 ? pActive : ""}>Contract administrators</p></div>
                        </div>
                        {<div className={paths.includes("/form/secondary") || paths.includes("/form/nomination") ? "clickable" : ""} onClick={handleNext("submit")}>
                            <div className={(progression === "/form/summary") || (item >= 5) ? "circleLarge" : circleInActive}></div>
                            <div className="p4 billing"><p className={item === 5 ? pActive : "" }>Submit</p></div>
                        </div>}                         
                    </div>
                    <div className={lineStyles}></div>
                </>
            }  
        </div>
    );
}

export default ProgressionBarLarge;
